module.exports = __webpack_public_path__ + "img/guatemala.99bc9280.png";